
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface TeacherPaymentStatusProps {
  status: string;
  lastPayment?: {
    date: string;
    amount: number;
  };
}

export const TeacherPaymentStatus: React.FC<TeacherPaymentStatusProps> = ({ 
  status,
  lastPayment
}) => {
  const getStatusColor = () => {
    switch (status.toLowerCase()) {
      case 'paid':
        return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300';
      case 'pending':
        return 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300';
      case 'overdue':
        return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300';
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300';
    }
  };
  
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-md">Payment Status</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col space-y-2">
          <Badge className={`self-start ${getStatusColor()}`}>{status}</Badge>
          
          {lastPayment && (
            <div className="text-sm text-muted-foreground">
              <p>Last payment: {new Date(lastPayment.date).toLocaleDateString()}</p>
              <p>Amount: {lastPayment.amount} AFN</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
